export default "__VITE_ASSET__5fa9f8d6__"